import './error-bar.scss';

import * as gzErrorBar from './error-bar.directive';

export default angular.module('gazelle.components.errorBar', [
])
  .directive(gzErrorBar.name, gzErrorBar.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/error-bar/error-bar.module.js